import { render, staticRenderFns } from "./ProductUnderwriting.vue?vue&type=template&id=4d82ce90"
import script from "./ProductUnderwriting.vue?vue&type=script&lang=js"
export * from "./ProductUnderwriting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports